import styled from 'styled-components';

export const PageContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	/* display: grid;
	grid-template-columns: 4fr 2.3fr 3.2fr;
	grid-template-rows: 1fr 1fr 1fr;
	gap: 40px 40px;
	grid-template-areas:
		'a a c'
		'd f b'
		'g h b';
	justify-items: start;
	.a {
		width: 100%;
		grid-area: a;
	}
	.b {
		width: 100%;
		grid-area: b;
	}
	.c {
		width: 100%;
		grid-area: c;
	}
	.d {
		width: 100%;
		grid-area: d;
	}
	.f {
		width: 100%;
		grid-area: f;
	}
	.g {
		width: 100%;
		grid-area: g;
	}
	.h {
		width: 100%;
		grid-area: h;
	} */
`;
